<ion-content class="invoice">
    <ng-container>
        <app-header [title]="(routeStopName ?? '') + ' (' + stopCode + ') : Invoice'" [breadcrumbs]="breadcrumbs"></app-header>
        <ion-grid style=" padding-top:120px">
            <div class="div-container">
                <ion-row>
                    <ion-header>Invoices</ion-header>
                </ion-row>
                <div class="loading-container" style="padding-top:10%" *ngIf="!loaded">
                    <ion-spinner></ion-spinner>
                </div>
                <ion-row *ngIf="invoices">
                    <div class="table-row">
                        <ngx-datatable
                        class="bootstrap"
                        [rows]="invoices.invoices"
                        [rowHeight]="50"
                        [sortType]="'multi'"
                        [headerHeight]="50"
                        [footerHeight]="50"
                        [columnMode]="'force'"
                        [scrollbarH]="false">
                       
                        <ngx-datatable-column name="Invoice" prop="invoiceCode">
                            <ng-template ngx-datatable-cell-template let-value="value">
                                <a (click)="openInvoice(value)" class="link">{{value}}</a>
                            </ng-template>
                        </ngx-datatable-column>
                        <ngx-datatable-column name="Date" prop="dateOfInvoice">
                            <ng-template ngx-datatable-cell-template let-value="value">
                                <a>{{value | date:'mediumDate'}}</a>
                            </ng-template>
                        </ngx-datatable-column>
                        <ngx-datatable-column name="Invoice Total" prop="amountDue">
                            <ng-template ngx-datatable-cell-template let-value="value">
                                <a>{{value | currency:'USD'}}</a>
                            </ng-template>
                        </ngx-datatable-column>
                        <ngx-datatable-column name="Due" prop="dueDate">
                            <ng-template ngx-datatable-cell-template let-value="value">
                                <a>{{value | date:'mediumDate'}}</a>
                            </ng-template>
                        </ngx-datatable-column>
                        <ngx-datatable-column name="Open Balance" prop="openBalance">
                            <ng-template ngx-datatable-cell-template let-value="value">
                                <a>{{value | currency:'USD'}}</a>
                            </ng-template>
                        </ngx-datatable-column>
                        </ngx-datatable>
                    </div>
                </ion-row>
            </div>
        </ion-grid>
    </ng-container>
</ion-content>